import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import classNames from 'classnames';

// Constants
import { drawingStates } from 'constants/values';

// Utils
import { getGoogleCredentials } from 'util/credentials';
import { getMessage } from 'util/locale';
// Actions
import { selectZone, removeActiveZoneSelection, setIsOverlayQuickSelectActive } from 'current/uiwidgets';
// Selectors
import { getBoundariesByFieldUuid } from 'boundaries/selectors';
import { getActiveFieldUuid, getSelectedZoneIds } from 'current/selectors';
import { getActiveScenario } from 'advanced/scenarios/selectors';
import { getAccountCountry, getProductValidationValues } from 'user/selectors';

// Components
import BaseMap from 'mapping/BaseMap';
import FieldOutlineLayer from 'mapping/layers/FieldOutlineLayer';
import ScenarioLayer from 'mapping/layers/ScenarioLayer';
import EditingLayer from 'mapping/layers/EditingLayer';
import { isEu9Limited } from 'constants/countryCodes';
const baseString = 'vra-review-scenario-map-panel';

/** Component for rendering map on Review Prescription screen (create advanced script flow).  */
let ReviewScenarioMapContainer = ({
  accountCountry,
  boundaries,
  productValidationValues,
  scenario,
  selectedZoneIds,
  // handlers
  onClickOutsideZones,
  onClickZone,
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    'with-density-tool': true
  });
  const disclaimer = isEu9Limited(accountCountry) 
    ? <span className={'vra-emea-disclaimer'}>{getMessage('disclaimer--emea-seed-density')}</span> 
    : null;

  
  return (
    <div className={classString} data-test-id='review-scenario-map'>
      <BaseMap
        boundaries={boundaries}
        boundariesPadding={0.005} // % padding around the field
        className='vra-map'
        googleCredentials={getGoogleCredentials()}
        onClick={onClickOutsideZones}
        onLeafletZoomEnd={() => undefined}
        showScale={false}>
        {boundaries && <FieldOutlineLayer boundaryGeoJson={boundaries} /> }
        {scenario
          && <ScenarioLayer
            productValidationValues={productValidationValues}
            scenario={scenario}
            selectedZoneIds={selectedZoneIds}
          />}
        {scenario
          && <EditingLayer
            drawingState={drawingStates.NONE}
            onClickZone={onClickZone}
            selectedZoneIds={selectedZoneIds}
            zones={scenario.zones}
          />
        }
      </BaseMap>
      {disclaimer}
    </div>
  );
};

ReviewScenarioMapContainer.propTypes = {
  accountCountry: propTypes.object,
  boundaries: propTypes.object,
  onClickOutsideZones: propTypes.func.isRequired,
  onClickZone: propTypes.func.isRequired,
  productValidationValues: propTypes.object,
  scenario: propTypes.object,
  selectedZoneIds: propTypes.arrayOf(propTypes.string).isRequired,
};

ReviewScenarioMapContainer = connect(
  (state) => {
    const fieldUuid = getActiveFieldUuid(state);
    return {
      accountCountry: getAccountCountry(state),
      boundaries: getBoundariesByFieldUuid(state, fieldUuid),
      productValidationValues: getProductValidationValues(state),
      scenario: getActiveScenario(state),
      selectedZoneIds: getSelectedZoneIds(state),
    };
  },
  (dispatch) => {
    const _isZoneLayer = (el) => el.nodeName.toLowerCase() === 'path';
    return {
      onClickZone: (zoneId) => { dispatch(selectZone({ mapWasClickedOnZoneSelect: true, zoneId })); },
      onClickOutsideZones: (event) => {
        dispatch(setIsOverlayQuickSelectActive(false));
        if (!_isZoneLayer(event.target)) {
          dispatch(removeActiveZoneSelection());
        }
      }
    };
  }
)(ReviewScenarioMapContainer);

export default ReviewScenarioMapContainer;
